import { useQuery } from '@apollo/client';
import { addDays, isAfter, startOfDay } from 'date-fns';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { GetMigrationToEpDataDocument } from './getMigrationToEPData.gql';

const TODAY = startOfDay(new Date());

const useGetMigrationToEpData = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error('companyProfileId is undefined in useGetMigrationToEpData');
  }

  const { data, ...rest } = useQuery(GetMigrationToEpDataDocument, {
    variables: { companyProfileId },
  });
  const hasBeenMigratedToEP =
    data?.viewer?.company?.metadata?.hasBeenMigratedToEP;
  const migratedToEPAt = data?.viewer?.company?.metadata?.migratedToEPAt;

  const startOfMigrationDay =
    hasBeenMigratedToEP && migratedToEPAt
      ? startOfDay(new Date(migratedToEPAt))
      : null;
  const hasBeenSevenDaysSinceMigrationStarted =
    hasBeenMigratedToEP && startOfMigrationDay
      ? isAfter(TODAY, addDays(startOfMigrationDay, 7))
      : false;

  return {
    ...rest,
    hasBeenMigratedToEP,
    hasBeenSevenDaysSinceMigrationStarted,
    migratedToEPAt,
  };
};

export default useGetMigrationToEpData;
